// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'dinRoundOT', 'dinRoundOT Fallback', Objektiv, sans-serif"},"className":"__className_a0b9cd","variable":"__variable_a0b9cd"};